export default {
  name: 'FontStyleMixin',
  computed: {
    weightOptions() {
      return [
        { value: 'normal', text: 'Normal' },
        { value: 'bold', text: 'Negrito' },
      ]
    },
    fontStyleOptions() {
      return [
        { value: 'normal', text: 'Normal' },
        { value: 'italic', text: 'Itálico' },
      ]
    },
    decorationOptions() {
      return [
        { value: 'none', text: 'Normal' },
        { value: 'line-through', text: 'Tachar' },
        { value: 'underline', text: 'Sublinhado' },
      ]
    },
  },
}
